<h6 *ngIf="navigation && navigation.title" class="mb-5">{{navigation.title | chooseTranslation}}</h6>
<div *ngIf="navigation">
	<app-navigation-item *ngFor="let navigationItem of navigation.items"
	                     [navigationItem]="navigationItem"
	                     class="nav nav-dark flex-column"></app-navigation-item>
</div>

